import { render } from "./defaultCurrency.vue?vue&type=template&id=3d7826ff"
import script from "./defaultCurrency.vue?vue&type=script&lang=js"
export * from "./defaultCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__